module.exports = __webpack_public_path__ + "img/shebeistatus2.1ff7901c.jpg";